// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ChooseActions_chooseActions__uPBDq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--background-secondary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.ChooseActions_topHeading__KeWzd {
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  display: flex;
  justify-content: space-between;
}

.ChooseActions_btmSection__nwqUc {
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ChooseActions_actionBox__pM8Lj {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  color: var(--text-primary, #1f2023);
  /* Body/Regular */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.5px;
  cursor: pointer;
  border-radius: 8px;
  padding-left: 10px;
}
.ChooseActions_actionBox__pM8Lj:hover {
  background: var(--background-hover, rgba(145, 160, 181, 0.1));
}

.ChooseActions_closeBox__j5uOH {
  cursor: pointer;
}

@media only screen and (max-width: 500px) {
  .ChooseActions_chooseActions__uPBDq {
    top: unset;
    bottom: 0;
    left: 0;
    transform: unset;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ChooseActions/ChooseActions.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,6CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAFD;;AAOA;EACC,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,aAAA;EACA,8BAAA;AAND;;AASA;EACC,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;AAPD;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EAEA,mCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,kBAAA;AAZD;AAcC;EACC,6DAAA;AAZF;;AAeA;EACC,eAAA;AAZD;;AAeA;EACC;IACC,UAAA;IACA,SAAA;IACA,OAAA;IACA,gBAAA;IACA,WAAA;EAZA;AACF","sourcesContent":[".chooseActions {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\twidth: 400px;\n\t// height: 100%;\n\tflex-shrink: 0;\n\tborder-radius: 8px;\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n\n\t// position: relative;\n}\n\n.topHeading {\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px; /* 125% */\n\tletter-spacing: -0.5px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.btmSection {\n\toverflow-y: auto;\n\tpadding: 10px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.actionBox {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 8px 0;\n\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Body/Regular */\n\tfont-family: Poppins;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px; /* 142.857% */\n\tletter-spacing: -0.5px;\n\n\tcursor: pointer;\n\n\tborder-radius: 8px;\n\n\tpadding-left: 10px;\n\n\t&:hover {\n\t\tbackground: var(--background-hover, rgba(145, 160, 181, 0.1));\n\t}\n}\n.closeBox {\n\tcursor: pointer;\n}\n\n@media only screen and (max-width: 500px) {\n\t.chooseActions {\n\t\ttop: unset;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: unset;\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chooseActions": `ChooseActions_chooseActions__uPBDq`,
	"topHeading": `ChooseActions_topHeading__KeWzd`,
	"btmSection": `ChooseActions_btmSection__nwqUc`,
	"actionBox": `ChooseActions_actionBox__pM8Lj`,
	"closeBox": `ChooseActions_closeBox__j5uOH`
};
export default ___CSS_LOADER_EXPORT___;
